module.exports = __webpack_public_path__ + "img/photo.dfbde877.svg";